export const theme = {
  colors: {
    primary: '#FF4D00',      // основной оранжевый
    secondary: '#007AFF',    // основной синий
    background: '#FFFFFF',   // белый фон
    light: '#F5F5F5',       // светло-серый
    text: {
      primary: '#2C2C2C',   // основной текст
      secondary: '#75A478',  // вторичный текст
      heading: '#030236'  // Добавляем цвет для заголовков
    }
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    h1: {
      fontSize: '3rem',
      fontWeight: 700
    }
  },
  transitions: {
    default: 'all 0.3s ease'
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.1)',
    large: '0 8px 24px rgba(0, 0, 0, 0.1)'
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px'
  },
  spacing: {
    section: '100px 0'
  }
};